import {
  AUTH_FAILURE, CLEAR_AUTH_FAILURE,
  GET_ACTIVE_USER,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS, SIGNIN_USER_COMPLETED,
  SIGNIN_USER_INITIATED,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  USER_PROFILE_UPDATE,
  SIGNUP_USER
} from 'constants/ActionTypes'

const INIT_STATE = {
  loader: false,
  initURL: '',
  authUser: null,
  profile: null,
  authenticationFailure: undefined,
  signInPending: false,
  activeUserEmail: null,
  userType: null,
  loginHash: null
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case AUTH_FAILURE: {
      return {
        ...state,
        signInPending: false,
        authenticationFailure: action.message
      }
    }

    case CLEAR_AUTH_FAILURE: {
      return {
        ...state,
        authenticationFailure: undefined
      }
    }
    
    case SIGNUP_USER: {
      return {
        ...state,
        userType: action.payload.type
      }
    }

    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: {
          signup: {
            complete: true
          }
        }
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload.authUser
      }
    }
    case USER_PROFILE_UPDATE: {
      return {
        ...state,
        profile: action.payload.profile
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }

    case SIGNIN_USER_INITIATED: {
      return {
        ...state,
        authUser: null,
        profile: null,
        signInPending: true,
        loginHash: action.payload.hash
      }
    }

    case GET_ACTIVE_USER: {
      return {
        ...state,
        activeUserEmail: action.payload.email
      }
    }

    case SIGNIN_USER_COMPLETED: {
      return {
        ...state,
        signInPending: false
      }
    }

    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        profile: null,
        initURL: '/',
        loader: false,
        signInPending: false
      }
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/Auth.js